import md5 from "md5";

const APPID = 1001;
const APP_KEY = "ae923rqwfvnlvugqrp23rnaf9832nrqfao";
export const md5SchoolDiagnoseSign = () => {
  const timestamp = Date.now().toString().substring(0, 10);
  return {
    appid: 1001,
    timestamp,
    sign: md5(APPID + "&" + timestamp + APP_KEY),
  };
};
